import './categories/category_list.scss'
import React from 'react';
import CloseIcon from '../assets/close_S.svg';
import parse from 'html-react-parser';
import arrowRightIcon from '../assets/Arrow_countryList.svg';
import BellIcon from '../assets/bell.svg';
import {CircleIcon} from './ui/circle-icon.js';

const CountryList = function (props) {
    return <div className={'category-list-container'}>
        {(props.bell) && <CircleIcon id={'share-button'}
                                     src={BellIcon}
                                     style={{
                                         backgroundColor: "#fff",
                                         borderTop: '1px solid grey',
                                         boxShadow: '0 -3px -6px rgba(0,0,0,0.16), 0 -3px -6px rgba(0,0,0,0.23)',
                                         position: 'absolute',
                                         cursor: 'default',
                                         top: -25,
                                         left: -5,
                                         fontSize: 20}}
                                     alt={'bell_icon'}/>}
        <img src={CloseIcon}
             alt={'close-icon'}
             style={{
                 cursor: 'pointer',
                 position: 'absolute',
                 top: 10,
                 right: 5,
             }}
             onClick={props.onClose}
        />
        {(props.title) && <h2 style={{margin: '10px 0 0', padding: 0}}>{props.title}</h2>}
        <p style={{paddingRight: 10, margin: 0, fontSize: '90%'}}>
            {props.description}
        </p>
        <>
            <p style={{color: '#a5aac2', fontSize: 13, fontWeight: 'bold', margin: '10px 0 0'}}>
                COUNTRY LIST:
            </p>
            <ul className={'category-list'}>
                {props.countries
                    .map((country) => {
                        return <li key={country.country_code}
                                   className={'category-list-item' + (country.hasCountryDetails ? '' : ' category-list-item-disabled')}
                                   onClick={country.hasCountryDetails ? ()=>props.onCountrySelect(country) : () => {}}>
                            <span>{parse(country.country_name)}</span>
                            {country.hasCountryDetails ?
                                <span style={{fontSize: 20}}>
                                        <img alt={'arrow_right'} src={arrowRightIcon} style={{width: 20}}/>
                                </span>:
                                null
                            }
                        </li>
                    })}
            </ul>
        </>
    </div>
};

export {CountryList}